var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ElementRef, EventEmitter, OnChanges } from '@angular/core';
import { SelectableNavigationItem } from '../../../../model/selectable-navigation-item';
import { PageNames } from '../../../../shared/page-names.enum';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { KeyDirections } from '../../../../shared/key-directions.enum';
var InputPincodeComponent = /** @class */ (function (_super) {
    __extends(InputPincodeComponent, _super);
    function InputPincodeComponent(navigationService) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        _this.emitPin = new EventEmitter();
        _this.emitPinRemoved = new EventEmitter();
        _this.emitOnBack = new EventEmitter();
        return _this;
    }
    InputPincodeComponent.prototype.ngAfterViewInit = function () {
        this.navigationService.registerNavigation(this, PageNames.PINCODE_MODAL);
    };
    InputPincodeComponent.prototype.onEnter = function () {
    };
    InputPincodeComponent.prototype.activate = function (active) {
        this.active = active;
        if (active) {
            if (this.pin.nativeElement.value) {
                this.emitPinRemoved.emit({ pin: this.pin.nativeElement.value });
                this.pin.nativeElement.value = '';
            }
            this.pin.nativeElement.focus();
        }
    };
    InputPincodeComponent.prototype.onInput = function (event) {
        if (!isNaN(event.value)) {
            this.emitPin.emit({
                pin: event.value
            });
        }
        else {
            this.pin.nativeElement.value = '';
        }
    };
    InputPincodeComponent.prototype.canNavigateToDirection = function (keyCode) {
        return this.pin.nativeElement.value || this.x <= 3 || keyCode !== KeyDirections.ARROW_RIGHT;
    };
    InputPincodeComponent.prototype.containsValue = function () {
        return this.pin.nativeElement.value !== '';
    };
    InputPincodeComponent.prototype.ngOnChanges = function (changes) {
        if (changes.pincodeIncorrect.currentValue) {
            this.pin.nativeElement.value = '';
        }
    };
    InputPincodeComponent.prototype.onBack = function () {
        this.emitOnBack.emit({
            value: true
        });
    };
    return InputPincodeComponent;
}(SelectableNavigationItem));
export { InputPincodeComponent };
